import IconDislikeSvg from "./assets/IconDislikeSvg";
import { DislikeTrackBtn as StyledLikeTrackBtn } from "./styled";

export const DislikeTrackBtn = ({ onClick, like }) => {
  return (
    <StyledLikeTrackBtn dislike={like === false} onClick={onClick}>
      <IconDislikeSvg />
    </StyledLikeTrackBtn>
  );
};
